import styled from 'styled-components';
import { colours } from 'themes/default';

export const StyledExchangeSummaryWrapper = styled.div`
  display: flex;
  width: 99%;
  margin-bottom: 20px;
`;

export const StyledDates = styled.p`
  font-weight: bold;
`;

export const StyledSummaryTickets = styled.div`
  width: 70%;
  box-sizing: border-box;
  padding: 8px;
  background-color: ${colours.Greyscale.MistGrey};
`;

export const StyledSummaryPaxs = styled.div`
  width: 30%;
  box-sizing: border-box;
  padding: 8px;
  background-color: ${colours.Greyscale.MistGrey};
`;

export const StyledTable = styled.table`
  width: 100%;
  height: 100%;
  padding: 8px;
  background-color: ${colours.Greyscale.White};
  font-weight: normal;

  td {
    vertical-align: top;
  }
`;

export const StyledPaxsTable = styled.table`
  width: 100%;
  height: 100%;
  padding: 8px;
  background-color: ${colours.Greyscale.White};
  font-weight: normal;

  td {
    &:nth-child(1) {
      font-weight: 500;
    }
    &:nth-child(2) {
      text-align: left;
      padding-left: 8px;
    }
  }
`;

export const StyledExchangeSummaryContainer = styled.div`
  padding: 8px 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: ${colours.Greyscale.White};
`;
